module.exports = __webpack_public_path__ + "img/18.85f74d86.jpg";